/* eslint-disable no-restricted-syntax */
/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { apiGetModel } from '../../../useApiHook';
import { callAxios } from '../../../../services/callAPIMiddleware';
// import { mapOrgUnitOptions } from '../mappingDtos';

const defaultErrorMsg = null;

export const useFetchPatientSearch = model => {
  const forceRefresh = model.forceRefresh;
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({
    response: null,
    isDataLoading: true,
    refresh: forceRefresh,
    error: defaultErrorMsg,
  });
  const [isTableDataLoading, setIsTableDataLoading] = useState(true);

  // Prepare api model and request call
  const getModel = apiGetModel('GetPatients', model, forceRefresh);

  const setRequestResponse = response => {
    setState(newState => ({
      ...newState,
      response,
      isDataLoading: false,
      refresh: false,
      error: null,
    }));
    setIsTableDataLoading(false);
  };

  const errorResponse = request => {
    if (!request.response) return;

    let errorMsg = '';
    const errorObj = JSON.parse(request.response);

    for (const value of Object.values(errorObj)) {
      errorMsg += `${value}. `; // `Field '${key}: ${value}. `;
    }

    setState(newState => ({
      ...newState,
      isDataLoading: false,
      refresh: false,
      error: { message: errorMsg, props: Object.keys(errorObj) },
    }));
    setTimeout(() => setState(newState => ({ ...newState, error: { ...newState.error, message: '' } })), 50);
  };

  useEffect(() => {
    if (jwtToken) {
      setIsTableDataLoading(true);
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          errorResponse(ex.request);
          setIsTableDataLoading(false);
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  // Returning strongly-type mappedDto object
  return {
    data: state.response ? state.response : [],
    isDataLoading: state.isDataLoading,
    auth,
    error: state.error,
    isTableDataLoading,
  };
};
